import { gql } from '@apollo/client';

export const SHOWCASE_FIRM = gql`
  fragment ShowcaseFirmFields on showcaseFirm {
    id
    name
    group
    backgroundColor
    isPaused
    createdBy
    siteIds
    updatedBy
    backgroundTextColor
    popupBackgroundColor
    seeInsideMessage
    dateCreated
    dateUpdated
    headerThinIndex
    updatedBy
    website
    logoUrl1
    logoUrl2
    buttonColor
    buttonText
    buttonTextColor
    moreInfoText
    googleAnalyticsTag
    siteIds
    representatives {
      id
      name
      phone
      email
      imageUrl
      showcaseFirmId
      createdBy
      updatedBy
      dateCreated
      dateUpdated
    }
  }
`;
